<template>
    <div class="pdf-viewer">
      <iframe 
        :src="pdfUrl" 
        width="100%" 
        height="600px" 
        frameborder="0">
      </iframe>
    </div>
  </template>
  
  <script>
  export default {
    name: "PdfViewer",
    props: {
      pdfUrl: {
        type: String,
        required: true, // URL of the PDF file (local or remote)
      },
    },
  };
  </script>
  
  <style scoped>
  .pdf-viewer iframe {
    border: none;
    width: 100%;
    height: 600px;
  }
  </style>
  